<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :height="333"
      border
    >
      <template v-slot:top>
        <div class="side-frame">
          <span class="side-frame-text">
            {{ $l('table_label_expense_item') || '费用填报明细' }}
          </span>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { format } from '@/libs/util.number.js'
export default {
  components: {},
  props: {
    disabled: { type: Boolean, default: false },
    materialAbnormalCode: { type: String, default: '' },
    custCode: { type: String, default: '' },
    custName: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      tableColumns: tableColumns(this),
      format: (number) => format(number),
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.materialAbnormalCode) return
      this.$api
        .materialAbnormalItemListApi({
          materialAbnormalCode: this.materialAbnormalCode,
        })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
  },
}
</script>
